// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"98d4296e","227":"a609db72","741":"37461acc","787":"441ea27f","985":"5f7255dd"}[chunkId] + ".chunk.js";
};